module.exports = __webpack_public_path__ + "img/tik-tok.23f2c639.svg";